import { desc, eq, type PowerSyncDrizzleDB, project_version } from "@time-tracker/powersync";

/**
 * LOCAL version history of a project (PROJECT VERSIONING) — PowerSync bucket
 * bounded to the sync window (last 10). id UUIDv7 ⇒ descending order = most
 * recent first. Deep history is fetched via API
 * (GET /api/chronos/project/:id/versions).
 */
export function getProjectVersionsQuery(db: PowerSyncDrizzleDB, projectId: string) {
  return db
    .select()
    .from(project_version)
    .where(eq(project_version.project_id, projectId))
    .orderBy(desc(project_version.id));
}
